import { DateTime } from 'luxon';

import { LessonJoinHintsQuery } from 'core/graphql';

export type JoinClickHint = {
  studentId: string;
  studentName: string;
  /** Local time (HH:mm) of the student's join click. */
  time: string;
};

export const transformJoinClicks = (data: LessonJoinHintsQuery | undefined): JoinClickHint[] => {
  if (!data?.lmsLessonJoinClicks) {
    return [];
  }

  return data.lmsLessonJoinClicks.reduce((hints: JoinClickHint[], click) => {
    if (!click) {
      return hints;
    }

    const studentId = String(click.studentId);

    // keep a single hint per student (the first click wins)
    if (hints.some((hint) => hint.studentId === studentId)) {
      return hints;
    }

    return [
      ...hints,
      {
        studentId,
        studentName: click.studentName,
        time: DateTime.fromISO(String(click.clickedAt)).toFormat('HH:mm'),
      },
    ];
  }, []);
};
